module.exports = __webpack_public_path__ + "static/icon_appstore-834dfc45c853863b7d5f3d7b3ef5f1a9.svg";